import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled from "styled-components";

export const StyledMobileVideo = styled.video`
  height: 88px;
  min-height: 88px;
  z-index: 0;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
  object-position: 0%;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    object-position: 15%;
  }
`;

export const StyledVideo = styled.video`
  height: 88px;
  min-height: 88px;
  position: absolute;
  left: 0;
  top: 0;
  width: 1260px;
  object-fit: cover;
  z-index: 0;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.neutral00};
  text-align: center;
  font-size: 36px;
  line-height: normal;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 28px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  z-index: 2;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    align-items: flex-end;
    bottom: unset;
    height: 100%;
    justify-content: center;
    left: unset;
    right: 52px;
    top: 0;
    transform: none;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    right: 40px;
  }
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral00};
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
`;

export const Disclaimer = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text4};
  font-size: 8px;
  line-height: 12px;
  text-align: right;

  br {
    display: none;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    line-height: 10px;

    br {
      display: block;
    }
  }
`;
